import React, { useState, useEffect } from 'react'
import { useKhTJ2Query } from '../../store/DianShangYeWuApi'
import { Form, Flex, Space, Table } from 'antd'
import Icon from '../../cpn/Icon'
import classes from '../statistic.module.css'
function StatisticArapClientTotal(props) {
    const [form] = Form.useForm();
    const [query, setQuery] = useState(false);
    const [list, setList] = useState([]);
    const {data,isSuccess} = useKhTJ2Query({qy_id:props.qy_id,}, { refetchOnMountOrArgChange: true,skip:!query});
    const formatAmount = (amount) => {
        if(amount){
            return Number(amount).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }else{
            return '0.00';
        }
    }
    const columns = [
        {
            title: '客户名称',
            dataIndex: 'kh_name',
            key: 'kh_name',            
        },       
        // {
        //     title: '应收',
        //     key: 'ddsr_ys',
        //     dataIndex: 'ddsr_ys',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        // {
        //     title: '核销应收',
        //     key: 'ddsr_hx',
        //     dataIndex: 'ddsr_hx',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        // {
        //     title: '应付',
        //     key: 'ddzc_yf',
        //     dataIndex: 'ddzc_yf',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        // {
        //     title: '核销应付',
        //     key: 'ddzc_hx',
        //     dataIndex: 'ddzc_hx',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        // {
        //     title: '费用应付',
        //     key: 'fy_yf',
        //     dataIndex: 'fy_yf',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        // {
        //     title: '借款应收',
        //     key: 'jk_amount',
        //     dataIndex: 'jk_amount',
        //     render: (text, record) => {
        //         return <span>￥{formatAmount(text)}</span>
        //     }
        // },
        {
            title: '小计',
            key: 'xj',  
            dataIndex: 'xj',
            render: (text, record) => {
                const xj = Number(record.ddsr_ys) - Number(record.ddsr_hx) - Number(record.ddzc_yf) + Number(record.ddzc_hx) - Number(record.fy_yf) + Number(record.jk_amount);
                if(xj>0){
                    return <span style={{color:'red'}}>应收余额￥{formatAmount(xj)}</span>
                }else if(xj<0){
                    return <span style={{color:'green'}}>应付余额￥{formatAmount(xj*-1)}</span>
                }else{
                    return <span>无</span>
                }
            }
        },
        
    ]
    useEffect(() => {
       if(isSuccess){
        if(data.Status==='success'){
            setList(Array.isArray(data.Result) ? data.Result : []);
        }else{
            setList([]);
        }
       }else{
        setList([]);
       }
    }, [isSuccess,data]);
    return (
        <>
            <Flex justify='flex-start'>
                <Form
                    layout='inline'
                    name='form_op'
                    form={form}
                    onFinish={(values) => {
                       
                       
                    }}
                    initialValues={{
                        date_range: [],
                       
                    }}
                >
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon 
                                type='search' 
                                onClick={() => {
                                    form.submit()
                                    setQuery(true)
                                }}
                            />                            
                        </Space>
                    </Form.Item>
                </Form>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={Array.isArray(list) ? list : []} 
                rowKey={(record) => record.danju_id + record.danju_type}
                bordered
                size='small'
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'10',
                    showTotal:(total) => `共${total}条`,
                }}
                className={classes.customTable}
                style={{marginTop:"10px",width:'100%'}}
                summary={pageData => {                    
                    let total = <span>无</span>;
                    const total_ddsr_ys = pageData.reduce((sum, row) => sum + Number(row.ddsr_ys || 0), 0);
                    const total_ddsr_hx = pageData.reduce((sum, row) => sum + Number(row.ddsr_hx || 0), 0);
                    const total_ddzc_yf = pageData.reduce((sum, row) => sum + Number(row.ddzc_yf || 0), 0);
                    const total_ddzc_hx = pageData.reduce((sum, row) => sum + Number(row.ddzc_hx || 0), 0);
                    const total_fy_yf = pageData.reduce((sum, row) => sum + Number(row.fy_yf || 0), 0);
                    const total_jk_amount = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);
                    const total_xj = total_ddsr_ys - total_ddsr_hx - total_ddzc_yf + total_ddzc_hx - total_fy_yf + total_jk_amount;
                    if(total_xj>0){
                        total = <span style={{color:'red'}}>应收￥{formatAmount(total_xj)}</span>
                    }else if(total_xj<0){
                        total = <span style={{color:'green'}}>应付￥{formatAmount(total_xj*-1)}</span>
                    }else{
                        total = <span>无</span>
                    }

                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1}>截止到当前，所有客户往来余额为{total}</Table.Summary.Cell>                            
                        </Table.Summary.Row>
                    );
                }} 
            />
        </>
    )
}

export default StatisticArapClientTotal